import { Injectable } from '@angular/core';
import { UserDataService } from '../data/user.service';
import {
  Observable,
  BehaviorSubject,
  Subscription,
  AsyncSubject,
  forkJoin,
  of,
} from 'rxjs';
import { map, switchMap, first, mergeAll } from 'rxjs/operators';
import {
  RegisteredUserModel,
} from '../interfaces/interfaces';

@Injectable({
  providedIn: 'root',
})
export class UserLogicService {
  constructor(
    private userDataService: UserDataService
  ) {}

  userLoginLogic(user: { email: string, password: string }) {
    return this.userDataService.userLogin(user)
  }

  userUpdateLogic(user: { _id: string, firstName: string, lastName: string, email: string, password: string }) {
    return this.userDataService.updateUser(user)
  }

  getAllRegisteredUsersLogic(): Observable<any> {
    return this.userDataService.getAllRegisteredUsers()
  }
}
